import { render, staticRenderFns } from "./ProductBundleCreate.vue?vue&type=template&id=63fe05bc&scoped=true&"
import script from "./ProductBundleCreate.vue?vue&type=script&lang=js&"
export * from "./ProductBundleCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fe05bc",
  null
  
)

export default component.exports